export default __webpack_public_path__ + "static/media/KluckAnimated.b91749a5.gif";